import React from 'react';

interface AutocompleteFormatVerpackungProps {
  suchvorschlag?: any;
}

export const AutocompleteFormatVerpackung = ({
  suchvorschlag,
}: AutocompleteFormatVerpackungProps) => {
  return (
    suchvorschlag && (
      <span>
        {suchvorschlag[`kurzBezeichnung`]}, {suchvorschlag[`langBezeichnung`]}
      </span>
    )
  );
};
